import { matchPath } from 'react-router-dom'

const context = '/portal'

export const isMatch = (path: string): boolean =>
  matchPath(
    `${path.replace(context || '', '').split('?')[0]}/*`,
    window.location?.pathname.replace(context || '', '')
  ) !== null
